import { deactivateButtonLoading } from './btn-loading';

const TOKEN_FIELD = 'g-recaptcha-response';

function ensureTokenInput(form) {
  let input = form.querySelector(`[name="${TOKEN_FIELD}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = TOKEN_FIELD;
    form.appendChild(input);
  }
  return input;
}

function showRecaptchaError(form) {
  const el = form.querySelector('[data-recaptcha-error]');
  if (!el) return;
  el.hidden = false;
}

function resetSubmitState(form) {
  form.classList.remove('is-loading', 'loadable--submit');
  document.querySelector('.app')?.classList.remove('is-loading');
  deactivateButtonLoading(
    form.querySelector('[type="submit"], button:not([type="button"])')
  );
}

function bindRecaptcha(form) {
  const siteKey = form.dataset.recaptchaSiteKey;
  if (!siteKey || form.dataset.recaptchaBound === 'true') return;

  form.dataset.recaptchaBound = 'true';

  form.addEventListener('submit', (event) => {
    if (form.dataset.recaptchaComplete === 'true') return;
    if (
      form.classList.contains('is-validatable') &&
      !form.classList.contains('is-valid')
    ) {
      return;
    }

    event.preventDefault();

    const action = form.dataset.recaptchaAction || 'register';

    const fail = () => {
      delete form.dataset.recaptchaComplete;
      resetSubmitState(form);
      showRecaptchaError(form);
    };

    const execute = () =>
      window.grecaptcha.execute(siteKey, { action }).then((token) => {
        if (!token) {
          fail();
          return;
        }
        ensureTokenInput(form).value = token;
        form.dataset.recaptchaComplete = 'true';
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });

    if (!window.grecaptcha) {
      fail();
      return;
    }

    const run = () => execute().catch(fail);

    if (typeof window.grecaptcha.ready === 'function') {
      window.grecaptcha.ready(run);
    } else {
      run();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('form[data-recaptcha-site-key]')
    .forEach(bindRecaptcha);
});
